import { isBlockingModalVisible, type BlockingModalOptions } from 'app/lib/blocking-modals';
import { navigationRef } from 'app/lib/root-navigation';
import {
  codeFullWarningAtom,
  presentFestivalReminderAtom,
  presentB2BActivatedModalAtom,
  presentB2CPaidModalAtom,
  presentCreateOfferModalAtom,
  presentSubscriptionCodeModalAtom,
  presentInsuredDetailsAtom,
  presentLoginSheet,
  presentGuestSignupPromptAtom,
  presentNewListingPrompt,
  presentNotificationModalAtom,
  presentPayWallAtom,
  presentSignUpSheet,
  presentUserMetaModalAtom,
} from 'app/atoms/ui';
import { useAtomValue } from 'jotai';
import { useSyncExternalStore } from 'react';

function subscribeNavigation(onStoreChange: () => void) {
  if (!navigationRef.isReady()) {
    return () => undefined;
  }
  return navigationRef.addListener('state', onStoreChange);
}

export function useIsBlockingModalVisible(options?: BlockingModalOptions) {
  // Re-render when any modal atom toggles.
  useAtomValue(presentNotificationModalAtom);
  useAtomValue(presentFestivalReminderAtom);
  useAtomValue(presentPayWallAtom);
  useAtomValue(presentB2BActivatedModalAtom);
  useAtomValue(presentB2CPaidModalAtom);
  useAtomValue(presentSubscriptionCodeModalAtom);
  useAtomValue(presentUserMetaModalAtom);
  useAtomValue(presentCreateOfferModalAtom);
  useAtomValue(presentNewListingPrompt);
  useAtomValue(presentSignUpSheet);
  useAtomValue(presentLoginSheet);
  useAtomValue(presentGuestSignupPromptAtom);
  useAtomValue(presentInsuredDetailsAtom);
  useAtomValue(codeFullWarningAtom);

  const getNavigationSnapshot = () => isBlockingModalVisible(options);

  return useSyncExternalStore(subscribeNavigation, getNavigationSnapshot, () => false);
}

/** Imperative check for callbacks outside React render (e.g. startTutorial). */
export { isBlockingModalVisible };
